import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faImage, faUpload } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import '../AdminCommon.css';
import './NewBanner.css';

export default function NewBanner({ onBannerCreated }) {
    const [cargando, setCargando] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenFile, setImagenFile] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setImagenPreview(null);
        setImagenFile(null);
        setModalOpen(!modalOpen);
    };

    const handleImagenChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImagenFile(file);
            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
        }
    };

    const crear = async (e) => {
        if (e) e.preventDefault();

        if (!imagenFile) {
            toast.warn('Por favor, selecciona una imagen para el banner.');
            return;
        }

        const formData = new FormData();
        formData.append('imagen', imagenFile);

        setCargando(true);
        try {
            const response = await fetch(`${baseURL}/bannersPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                toggleModal();
                if (typeof onBannerCreated === 'function') {
                    onBannerCreated();
                } else {
                    window.location.reload();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al subir banner:', error);
            toast.error('Error de conexión. Por favor, inténtalo de nuevo.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div>
            <button onClick={toggleModal} className="adminBtnPrimary" title="Publicar nuevo banner en la tienda">
                <FontAwesomeIcon icon={faPlus} /> Agregar banner
            </button>

            {modalOpen && (
                <div className="adminModalOverlay" onClick={toggleModal}>
                    <div className="adminModalContent modalSmallSimple" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader">
                            <h3><FontAwesomeIcon icon={faImage} /> Agregar Banner Promocional</h3>
                            <button type="button" className="adminModalClose" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={crear}>
                            <div className="adminModalBody">
                                <p style={{ margin: '0 0 0.85rem 0', fontSize: '13px', color: '#64748b' }}>
                                    Selecciona una imagen de alta calidad para la cabecera de la tienda digital.
                                </p>

                                <div className="bannerUploadArea">
                                    <div className="bannerPreviewBox">
                                        {imagenPreview ? (
                                            <img src={imagenPreview} alt="Vista previa del banner" className="bannerImgPreview" />
                                        ) : (
                                            <div className="emptyBannerSlot">
                                                <FontAwesomeIcon icon={faImage} />
                                                <span>Vista previa no disponible</span>
                                            </div>
                                        )}
                                    </div>

                                    <label className="btnSelectBannerFile">
                                        <FontAwesomeIcon icon={faUpload} /> Seleccionar Imagen
                                        <input
                                            type="file"
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            onChange={handleImagenChange}
                                            required
                                        />
                                    </label>
                                </div>
                            </div>

                            <div className="adminModalFooter">
                                <button type="button" className="adminBtnSecondary" onClick={toggleModal} disabled={cargando}>
                                    Cancelar
                                </button>
                                <button type="submit" className="adminBtnPrimary" disabled={cargando || !imagenFile}>
                                    {cargando ? 'Subiendo...' : 'Publicar Banner'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
